import axios from 'axios'

export default {
    initialize: function () {
        window.apiDev = getParamValue('dev')
        window.width = getParamValue('width') ? parseInt(getParamValue('width')) : 200
        window.height = getParamValue('height') ? parseInt(getParamValue('height')) : 200
        window.imagesize = 800
        window.color = getParamValue('color') ? getParamValue('color') : null
        window.language = getLanguage()
        window.apiKey = 'common'

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            } else {
                return 'pt'
            }
        }
    },
    updateAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        axios.defaults.authorization = 'Basic ' + window.btoa(user + ':' + password)
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            const responseData = response && response.request && response.request.response ? JSON.parse(response.request.response) : {
                success: false,
                data: null,
                message: self.getMessageError(response),
            }
            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    getMessageError: function (response) {
        let messageError = window.strings && window.strings['server_connection_failed'] ? window.strings['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }
        return messageError
    },
    getAlertOptions: function () {
        const str = window.strings ? window.strings : {
            'ok': 'Ok',
            'cancel': 'Cancelar'
        }
        return {
            confirmButtonText: str['ok'],
            cancelButtonText: str['cancel']
        }
    },
}
